(function () {
	'use strict';

	angular.module('mx.components').directive('mxForm', function mxFormDirective() {
		return {
			require: {
				mxFormCtrl: '?form',
			},
			replace: true,
			scope: {},
			bindToController: {
				objectId: '=?',
				displayStrings: '=?',
				disabled: '=?',
				templateReadOnly: '<readOnly',
				onReadOnlyChanged: '&',
				entity: '=?',
				entityName: '=?',
				dirty: '=?',
				isLoading: '=?',
				context: '=?',
			},
			controller: MxFormCtrl,
			controllerAs: 'vm',
		};
	});

	MxFormCtrl.$inject = [];
	function MxFormCtrl() {
		var vm = this;
		var objectId;
		var externalReadOnly = {},
			externalReadOnlyAll = false,
			templateReadOnly = false,
			readOnly = false;

		vm.$onInit = function () {
			if (vm.readOnly) {
				vm.onReadOnlyChanged({ readOnly: vm.readOnly });
			}
		};

		Object.defineProperties(vm, {
			objectId: {
				get: function () {
					return objectId || (vm.context && vm.context.objectId);
				},
				set: function (value) {
					objectId = value;
				},
			},
			valid: {
				get: function () {
					return vm.mxFormCtrl.$valid;
				},
			},
			dirty: {
				get: function () {
					return vm.mxFormCtrl.$dirty;
				},
				set: function (value) {
					if (value) {
						vm.setDirty();
					}
				},
			},
			readOnly: {
				// property to get readOnly status of the form for all components
				get: function () {
					return readOnly;
				},
			},
			externalReadOnly: {
				get: function () {
					return externalReadOnlyAll;
				},
			},
			templateReadOnly: {
				// Interface property: property can be set with read-only attribute in templates (ex. in dialog-content and edit-form of multi-fragment)
				get: function () {
					return templateReadOnly;
				},
				set: function (value) {
					templateReadOnly = value;
					vm._updateReadOnly();
				},
			},
			setExternalReadOnly: {
				// Interface method: can be set with injection in other controls (ex. readOnly-form)
				writable: false,
				value: function (value, name) {
					name = typeof name === 'string' && name.length ? name : 'default';
					externalReadOnly[name] = Boolean(value);

					externalReadOnlyAll = Object.keys(externalReadOnly).some(function (name) {
						return externalReadOnly[name];
					});

					vm._updateReadOnly();
				},
			},
			_updateReadOnly: {
				// internal method: set readOnly from external and template interfaces
				writable: false,
				value: function () {
					var newValue = templateReadOnly || this.externalReadOnly;
					if (readOnly !== newValue) {
						readOnly = newValue;

						if (vm.onReadOnlyChanged) {
							vm.onReadOnlyChanged({ readOnly: readOnly });
						}
					}
				},
			},
			addDirtyIgnoredControls: {
				writable: false,
				value: function (controls) {
					if (Array.isArray(controls)) {
						controls.forEach(function (controlName) {
							if (typeof vm.mxFormCtrl[controlName] === 'object') {
								vm.mxFormCtrl[controlName].$pristine = false;
							}
						});
					}
				},
			},
			setDirty: {
				writable: false,
				value: function () {
					vm.mxFormCtrl?.$setDirty();
				},
			},
		});
	}
})();
